import type { PaymentRecord } from "../mocks/payments";
import { createServerStateStore } from "../lib/serverState";

const store = createServerStateStore<PaymentRecord[]>("payments", []);

export function getPayments() {
  return store.getState();
}

export async function rehydratePayments() {
  return store.rehydrate();
}

export async function setAllPayments(
  updater: PaymentRecord[] | ((prev: PaymentRecord[]) => PaymentRecord[])
) {
  return store.setState(updater);
}

export function subscribePayments(listener: () => void) {
  return store.subscribe(listener);
}

export async function resetPaymentsStore() {
  return store.reset();
}